export default {
  Small: 12,
  Medium: 13,
  Large: 15,
  XLarge: 17,
  XXLarge: 19
};
